const handleCenterPaddingDesktop = (plansCount) => {
  if (plansCount === 5) {
    return 35;
  }
  if (plansCount === 4) {
    return 75;
  }
  if (plansCount === 3) {
    return 200;
  }
  if (plansCount === 2) {
    return 310;
  }
  return 430;
};

const settings = (plansCount) => ({
  className: "center",
  centerMode: true,
  infinite: false,
  centerPadding: handleCenterPaddingDesktop(plansCount),
  slidesToShow: plansCount,
  speed: 500,
  arrows: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        centerPadding: "60px",
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        centerPadding: "40px",
      },
    },
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 1,
        centerPadding: "55px",
      },
    },
  ],
});

export { settings as default };
